import Ajax from "./ajax";

const MYAPP = 'myApp';
const NOTMYAPP = 'notMyApp';
const MYAPPINFO = 'myAppInfo';
const MYCOLLECT = 'myCollect';
const RECENTVISIT = 'recentVisit';

// 查询bip的菜单
export function getCloudMenus(params = {}) {
    return new Promise(resolve => {
        Ajax({
            url: '/nccloud/platform/appregister/querycloudappmenu.do',
            data: { apptype: '1' },
            ...params,
            success: res => {
                const { data, success } = res.data;
                if (success && data) {
                    resolve(data);
                } else {
                    resolve([]);
                }
            },
            error: () => {
                resolve([]);
            }
        });
    });
}

export function getMenus(params) {
    return new Promise(resolve => {
        Ajax({
            url: '/nccloud/platform/appregister/queryapplazy.do',
            ...params,
            success: res => {
                const { data, success } = res.data;
                if (success && data) {
                    resolve(data);
                } else {
                    resolve([]);
                }
            },
            error: () => {
                resolve([]);
            }
        });
    });
}

export {
    MYAPP,
    NOTMYAPP,
    MYAPPINFO,
    MYCOLLECT,
    RECENTVISIT,
}